export default [
	{
		modulo: 13,
		privilegio: 106,
		routerName: 'prevencao-qualificada',
		routerPath: '/prevencao-qualificada',
		componentName: 'PrevencaoQualificada',
		componentPath: 'modules/layout/prevencao/main'
	}
]
